import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { noAuthRoutes, useRoutes, userMenuRoutes } from './items';
import { Permission, Route as RoutePath } from '@/enums';
import { useAppContext } from '@/context';
import { GroupRouteItem, RouteItem } from './types';
import { AuthorizationSuccess } from '@/pages/BankAuthorizations/AuthorizationSuccess';
import { Layout } from '@/components';

export const Routes = () => {
  const { loggedIn, hasPermission } = useAppContext();
  const routes = useRoutes();
  const applicableRoutes = loggedIn ? getAuthorizedRoutes(routes) : noAuthRoutes;
  const routeElements = applicableRoutes
    .filter((item) => 'page' in item && item.page && 'path' in item && item.path)
    .map(mapRoute);
  const redirectElement = getRedirectElement(loggedIn, hasPermission);

  return (
    <RouterRoutes>
      <Route path='/authorizationsuccess' element={<AuthorizationSuccess />} />
      <Route path='/' element={<Layout />}>
        {routeElements}
        <Route index element={redirectElement} />
        <Route path='*' element={redirectElement} />
      </Route>
    </RouterRoutes>
  );
};

const getAuthorizedRoutes = (routes: GroupRouteItem[]): RouteItem[] => {
  const topLevelRoutes = routes.map(({ items, ...rest }) => rest);
  const subroutes = routes.flatMap((x) => x.items ?? []);

  return [...topLevelRoutes, ...subroutes, ...userMenuRoutes];
};

const mapRoute = ({ path, page: module }: RouteItem) => {
  const Module = module as () => JSX.Element;
  return <Route key={path} path={path} element={<Module />} />;
};

const getRedirectElement = (
  loggedIn: boolean,
  hasPermission: (permission: Permission) => boolean,
) => {
  let redirectPath = RoutePath.Login;

  if (loggedIn) {
    if (hasPermission(Permission.DashboardView)) {
      redirectPath = RoutePath.Dashboard;
    } else if (hasPermission(Permission.HrStroriesGenerator)) {
      redirectPath = RoutePath.Generator;
    } else {
      redirectPath = RoutePath.PasswordChange;
    }
  }

  return <Navigate to={redirectPath} replace />;
};
